<template>
  <main class="checkup-home-page">
    <section class="hero">
      <div class="status-bar">
        <span>9:41</span>
        <div class="status-icons">
          <span class="signal" />
          <span class="wifi" />
          <span class="battery"><i /></span>
        </div>
      </div>
      <div class="header-row">
        <div>
          <h1>体检中心</h1>
          <p>专注 · 高效 · 创新</p>
        </div>
        <div class="capsule" aria-hidden="true">
          <span />
          <span />
          <span />
          <i />
          <b />
        </div>
      </div>
      <form class="search-bar" @submit.prevent="handleSearch">
        <van-icon name="search" class="search-icon" />
        <input v-model.trim="keyword" type="search" placeholder="搜索体检项目、套餐、服务">
        <button type="submit">搜索</button>
      </form>
    </section>
    <section class="quick-panel">
      <button
        v-for="item in quickEntries"
        :key="item.name"
        type="button"
        class="quick-item"
        @click="handleEntryClick(item)"
      >
        <span :class="['quick-icon', item.color]">
          <van-icon :name="item.icon" />
        </span>
        <span>{{ item.name }}</span>
      </button>
    </section>
    <section class="banner-card" @click="handleBannerClick">
      <div>
        <h2>{{ banner.title }}</h2>
        <p>{{ banner.subtitle }}</p>
      </div>
      <div class="banner-art">
        <van-icon name="gift-o" />
      </div>
    </section>
    <button type="button" class="notice-card" @click="handleNoticeClick">
      <span class="notice-icon">
        <van-icon name="info-o" />
      </span>
      <strong>体检须知</strong>
      <span>流程、注意事项、报告说明</span>
      <van-icon name="arrow" class="notice-arrow" />
    </button>
    <section class="section-block">
      <div class="section-head">
        <h2>体检项目</h2>
        <button type="button" @click="handleFilterClick">分类筛选</button>
      </div>
      <div class="category-panel">
        <button
          v-for="item in categories"
          :key="item.id"
          type="button"
          class="category-item"
          @click="handleCategoryClick(item)"
        >
          <span :class="['category-icon', item.tone]">
            <van-icon :name="item.icon" />
          </span>
          <span>{{ item.name }}</span>
        </button>
        <div class="pager">
          <i />
          <i />
        </div>
      </div>
    </section>
    <section class="section-block package-section">
      <div class="section-title-row">
        <h2>套餐推荐</h2>
        <span>让健康事项可控</span>
      </div>
      <div class="package-list">
        <button
          v-for="item in packages"
          :key="item.id"
          type="button"
          class="package-card"
          @click="handlePackageClick(item)"
        >
          <span :class="['package-icon', item.tone]">
            <van-icon :name="item.icon" />
          </span>
          <span class="package-info">
            <strong>{{ item.name }}</strong>
            <em>{{ item.description }}</em>
            <span class="package-meta">
              <b :class="item.tagTone">{{ item.tag }}</b>
              <i>{{ item.count }}人</i>
            </span>
          </span>
        </button>
      </div>
    </section>
    <nav class="tab-bar">
      <button
        v-for="item in tabs"
        :key="item.name"
        type="button"
        :class="{ active: activeTab === item.name }"
        @click="handleTabClick(item)"
      >
        <van-icon :name="item.icon" />
        <span>{{ item.name }}</span>
      </button>
      <i class="home-indicator" />
    </nav>
  </main>
</template>

<script>
export default {
  name: 'CheckupHome',
  data() {
    return {
      keyword: '',
      activeTab: '首页',
      banner: {
        id: 'family-package',
        title: '超值体检套餐-家庭版',
        subtitle: '新客优惠，自由选择体检类型'
      },
      quickEntries: [
        { name: '体检预约', icon: 'calendar-o', color: 'blue', path: '/checkup-reservation' },
        { name: '体检报告', icon: 'records', color: 'green', path: '/checkup-report' },
        { name: '我的订单', icon: 'orders-o', color: 'purple', path: '/checkup-orders' },
        { name: '体检人管理', icon: 'contact', color: 'orange', path: '/checkup-members' }
      ],
      categories: [
        { id: 'entry', name: '入职体检', icon: 'bag-o', tone: 'green' },
        { id: 'drive', name: '驾驶体检', icon: 'logistics', tone: 'blue' },
        { id: 'elder-care', name: '敬老体检', icon: 'friends-o', tone: 'orange' },
        { id: 'senior', name: '老年体检', icon: 'shield-o', tone: 'pink' },
        { id: 'women', name: '妇检全检', icon: 'female', tone: 'green' },
        { id: 'chronic', name: '慢病筛查', icon: 'chart-trending-o', tone: 'blue' },
        { id: 'premium', name: '高端体检', icon: 'gem-o', tone: 'orange' },
        { id: 'special', name: '专项体检', icon: 'bookmark-o', tone: 'pink' }
      ],
      packages: [
        {
          id: 'hp-check',
          name: '幽门筛查套餐',
          description: '胃部风险筛查',
          tag: '推荐',
          tagTone: 'green',
          count: 2025,
          icon: 'medal-o',
          tone: 'green'
        },
        {
          id: 'breast-check',
          name: '乳腺专项检查',
          description: '女性健康筛查',
          tag: '热销',
          tagTone: 'orange',
          count: 2025,
          icon: 'like-o',
          tone: 'orange'
        }
      ],
      tabs: [
        { name: '首页', icon: 'wap-home-o', path: '/checkup-home' },
        { name: '套餐权益', icon: 'coupon-o', path: '/checkup-benefits' },
        { name: '我的', icon: 'manager-o', path: '/checkup-mine' }
      ]
    }
  },
  created() {
    this.$store.dispatch('settings/setTitle', '体检中心')
  },
  methods: {
    handleSearch() {
      if (!this.keyword) {
        this.showToast('请输入搜索内容')
        return
      }
      this.showToast(`搜索：${this.keyword}`)
    },
    handleEntryClick(item) {
      this.showToast(`${item.name}功能待接入`)
    },
    handleBannerClick() {
      this.showToast('活动详情待接入')
    },
    handleNoticeClick() {
      this.showToast('体检须知待接入')
    },
    handleFilterClick() {
      this.showToast('分类筛选待接入')
    },
    handleCategoryClick(item) {
      this.showToast(`${item.name}列表待接入`)
    },
    handlePackageClick(item) {
      this.showToast(`${item.name}详情待接入`)
    },
    handleTabClick(item) {
      this.activeTab = item.name
      if (item.name === '首页') {
        return
      }
      this.showToast(`${item.name}功能待接入`)
    },
    showToast(message) {
      if (this.$toast) {
        this.$toast(message)
        return
      }
      this.$message.info(message)
    }
  }
}
</script>

<style lang="scss" scoped>
.checkup-home-page {
  position: relative;
  width: 100%;
  max-width: 375px;
  min-height: 100vh;
  margin: 0 auto;
  padding-bottom: 88px;
  overflow-x: hidden;
  background: #f5f9f8;
  color: #17252f;
  font-family: -apple-system, BlinkMacSystemFont, 'PingFang SC', 'Helvetica Neue', Arial, sans-serif;
  box-sizing: border-box;
}

.checkup-home-page * {
  box-sizing: border-box;
}

button,
input {
  font: inherit;
}

button {
  padding: 0;
  border: 0;
  background: transparent;
}

.hero {
  height: 188px;
  padding: 12px 15px 0;
  background: #10c694;
  color: #fff;
}

.status-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 20px;
  padding: 0 10px 0 7px;
  font-size: 13px;
  font-weight: 600;
  line-height: 20px;
}

.status-icons {
  display: flex;
  align-items: center;
  gap: 5px;
}

.signal {
  width: 18px;
  height: 8px;
  border-radius: 2px;
  background: #eafff9;
}

.wifi {
  width: 14px;
  height: 8px;
  border-radius: 2px;
  background: #eafff9;
}

.battery {
  position: relative;
  width: 18px;
  height: 10px;
  border: 1.5px solid #eafff9;
  border-radius: 2px;
}

.battery::after {
  position: absolute;
  top: 2px;
  right: -3px;
  width: 2px;
  height: 4px;
  border-radius: 0 1px 1px 0;
  background: #eafff9;
  content: '';
}

.battery i {
  display: block;
  width: 12px;
  height: 4px;
  margin: 2px;
  border-radius: 1px;
  background: #eafff9;
}

.header-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-top: 7px;
  padding: 0 0 0 3px;
}

.header-row h1 {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  line-height: 30px;
}

.header-row p {
  margin: 2px 0 0;
  font-size: 13px;
  line-height: 18px;
}

.capsule {
  display: flex;
  align-items: center;
  width: 72px;
  height: 28px;
  margin-top: 3px;
  padding: 0 8px 0 13px;
  border-radius: 16px;
  background: rgba(0, 108, 86, 0.35);
}

.capsule span {
  width: 4px;
  height: 4px;
  margin-right: 4px;
  border-radius: 50%;
  background: #fff;
}

.capsule i {
  width: 1px;
  height: 16px;
  margin: 0 13px 0 6px;
  background: rgba(255, 255, 255, 0.55);
}

.capsule b {
  width: 10px;
  height: 10px;
  border: 1.5px solid #fff;
  border-radius: 50%;
}

.search-bar {
  display: flex;
  align-items: center;
  height: 34px;
  margin-top: 16px;
  padding: 3px 3px 3px 13px;
  border-radius: 18px;
  background: #fff;
}

.search-icon {
  flex: 0 0 auto;
  margin-right: 6px;
  color: #b6c1c0;
  font-size: 16px;
}

.search-bar input {
  min-width: 0;
  flex: 1;
  height: 28px;
  border: 0;
  outline: none;
  color: #273b45;
  font-size: 14px;
  line-height: 28px;
}

.search-bar input::placeholder {
  color: #a4b0af;
}

.search-bar button {
  width: 60px;
  height: 28px;
  border-radius: 15px;
  background: #16bf8b;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  line-height: 28px;
}

.quick-panel {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  width: calc(100% - 30px);
  min-height: 100px;
  margin: -38px auto 14px;
  padding: 18px 12px 10px;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 9px 20px rgba(24, 72, 70, 0.08);
}

.quick-item {
  display: flex;
  min-width: 0;
  flex-direction: column;
  align-items: center;
  color: #2f363a;
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;
}

.quick-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 46px;
  margin-bottom: 8px;
  border-radius: 50%;
  color: #fff;
  font-size: 26px;
  box-shadow: 0 6px 12px rgba(25, 35, 50, 0.12);
}

.quick-icon.blue {
  background: #25aefa;
}

.quick-icon.green {
  background: #04ca9a;
}

.quick-icon.purple {
  background: #7160e9;
}

.quick-icon.orange {
  background: #ff6d00;
}

.banner-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: calc(100% - 30px);
  height: 70px;
  margin: 0 auto 12px;
  padding: 13px 31px 12px 17px;
  border-radius: 9px;
  background: linear-gradient(90deg, #fff8e7 0%, #f9f5ed 100%);
}

.banner-card h2 {
  margin: 0;
  color: #27343a;
  font-size: 18px;
  font-weight: 800;
  line-height: 24px;
}

.banner-card p {
  margin: 3px 0 0;
  color: #96a09c;
  font-size: 13px;
  line-height: 18px;
}

.banner-art {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #ff7a00;
  color: #fff;
  font-size: 29px;
}

.notice-card {
  display: flex;
  align-items: center;
  width: calc(100% - 30px);
  height: 56px;
  margin: 0 auto 18px;
  padding: 0 10px 0 16px;
  border: 1px solid #e8f0ef;
  border-radius: 10px;
  background: #fff;
  color: #2b3439;
}

.notice-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  margin-right: 10px;
  border-radius: 50%;
  background: #e6fbf4;
  color: #10c694;
  font-size: 17px;
}

.notice-card strong {
  margin-right: 10px;
  font-size: 16px;
  line-height: 20px;
  white-space: nowrap;
}

.notice-card > span:not(.notice-icon) {
  min-width: 0;
  flex: 1;
  overflow: hidden;
  color: #87908f;
  font-size: 13px;
  line-height: 18px;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.notice-arrow {
  flex: 0 0 auto;
  color: #b7c0bd;
  font-size: 16px;
}

.section-block {
  width: calc(100% - 30px);
  margin: 0 auto;
}

.section-head,
.section-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 32px;
}

.section-head h2,
.section-title-row h2 {
  margin: 0;
  color: #1c2c33;
  font-size: 17px;
  font-weight: 800;
  line-height: 24px;
}

.section-head button,
.section-title-row span {
  color: #a8b0af;
  font-size: 12px;
  line-height: 16px;
}

.category-panel {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  position: relative;
  min-height: 150px;
  padding: 12px 13px 22px;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 8px 18px rgba(27, 65, 64, 0.05);
}

.category-item {
  display: flex;
  min-width: 0;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  height: 58px;
  margin-bottom: 8px;
  color: #354045;
  font-size: 13px;
  line-height: 16px;
}

.category-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  margin-bottom: 7px;
  border-radius: 50%;
  font-size: 22px;
}

.category-icon.green {
  background: #e7fbf5;
  color: #09c796;
}

.category-icon.blue {
  background: #edf8ff;
  color: #1eb2ff;
}

.category-icon.orange {
  background: #fff3e9;
  color: #ff7114;
}

.category-icon.pink {
  background: #fff0f7;
  color: #f55f9f;
}

.pager {
  position: absolute;
  left: 50%;
  bottom: 10px;
  display: flex;
  transform: translateX(-50%);
}

.pager i {
  width: 6px;
  height: 4px;
  margin: 0 2px;
  border-radius: 2px;
  background: #d9e8e5;
}

.pager i:first-child {
  width: 18px;
  background: #15c391;
}

.package-section {
  margin-top: 14px;
}

.section-title-row {
  justify-content: flex-start;
}

.section-title-row h2 {
  margin-right: 12px;
}

.package-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 13px;
  margin-top: 0;
}

.package-card {
  display: flex;
  min-width: 0;
  height: 76px;
  padding: 10px;
  border-radius: 9px;
  background: #fff;
  box-shadow: 0 7px 16px rgba(26, 52, 54, 0.06);
  text-align: left;
}

.package-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 36px;
  width: 36px;
  height: 36px;
  margin: 5px 8px 0 0;
  border-radius: 50%;
  font-size: 22px;
}

.package-icon.green {
  background: #e9fbf6;
  color: #09c796;
}

.package-icon.orange {
  background: #fff3ea;
  color: #ff7615;
}

.package-info {
  display: flex;
  min-width: 0;
  flex: 1;
  flex-direction: column;
}

.package-info strong {
  overflow: hidden;
  color: #26363d;
  font-size: 13px;
  font-weight: 800;
  line-height: 18px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.package-info em {
  overflow: hidden;
  margin-top: 2px;
  color: #87918f;
  font-size: 12px;
  font-style: normal;
  line-height: 16px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.package-meta {
  display: flex;
  align-items: center;
  margin-top: 4px;
}

.package-meta b {
  width: 38px;
  height: 18px;
  margin-right: 8px;
  border-radius: 9px;
  font-size: 11px;
  font-weight: 500;
  line-height: 18px;
  text-align: center;
}

.package-meta b.green {
  background: #e7faf4;
  color: #0fc995;
}

.package-meta b.orange {
  background: #fff1e5;
  color: #ff7920;
}

.package-meta i {
  color: #bdc3c1;
  font-size: 11px;
  font-style: normal;
  line-height: 14px;
}

.tab-bar {
  position: fixed;
  left: 50%;
  bottom: 0;
  z-index: 9;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  width: 100%;
  max-width: 375px;
  height: 66px;
  padding-top: 7px;
  border-top: 1px solid #e5ecea;
  background: #fff;
  transform: translateX(-50%);
}

.tab-bar button {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #54615f;
  font-size: 11px;
  line-height: 14px;
}

.tab-bar .van-icon {
  margin-bottom: 4px;
  font-size: 22px;
}

.tab-bar button.active {
  color: #10c694;
}

.home-indicator {
  position: absolute;
  left: 50%;
  bottom: 6px;
  width: 103px;
  height: 4px;
  border-radius: 2px;
  background: #d4d8d6;
  transform: translateX(-50%);
}

@media (max-width: 340px) {
  .quick-panel {
    padding-right: 8px;
    padding-left: 8px;
  }

  .quick-item,
  .category-item {
    font-size: 12px;
  }

  .banner-card h2 {
    font-size: 16px;
  }

  .notice-card strong {
    margin-right: 7px;
    font-size: 15px;
  }

  .package-list {
    gap: 8px;
  }

  .package-card {
    padding-right: 7px;
    padding-left: 7px;
  }

  .package-icon {
    margin-right: 6px;
  }
}
</style>
